import "core-js/modules/es.array.push.js";
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  class: "flex-center loginPage"
};
const _hoisted_2 = {
  class: "left flex-center"
};
const _hoisted_3 = {
  class: "right"
};
const _hoisted_4 = {
  class: "login-box"
};
const _hoisted_5 = {
  key: 0,
  class: "wechatLog flex-center"
};
const _hoisted_6 = ["href"];
const _hoisted_7 = {
  class: "input-form"
};
import { onMounted, ref, reactive } from "vue";
import { httpGet, httpPost } from "@/utils/http";
import { useRouter } from "vue-router";
import AccountBg from "@/components/AccountBg.vue";
import { isMobile } from "@/utils/libs";
import { checkSession, getLicenseInfo, getSystemInfo } from "@/store/cache";
import * as LoginApi from '@/api/login';
import { setUserToken } from "@/store/session";
import { showMessageError, showMessageInfo } from "@/utils/dialog";
import { setRoute } from "@/store/system";
import { useSharedStore } from "@/store/sharedata";
import * as authUtil from '@/utils/auth';
import AccountTop from "@/components/AccountTop.vue";
import Captcha from "@/components/Captcha.vue";
export default {
  __name: 'Login',
  setup(__props) {
    const router = useRouter();
    const title = ref("LEHE-AI");
    const logo = ref("");
    const licenseConfig = ref({});
    const wechatLoginURL = ref("");
    const enableVerify = ref(false);
    const captchaRef = ref(null);
    const ruleFormRef = ref(null);
    const ruleForm = reactive({
      type: "personal",
      // username: process.env.VUE_APP_USER,
      // password: process.env.VUE_APP_PASS,
      username: '',
      password: ''
    });
    const validateTenant = (rule, value, callback) => {
      if (!value && ruleForm.type === 'enterprise') {
        callback(new Error('请输入租户编码'));
      } else {
        callback();
      }
    };
    const rules = {
      tenantCode: [{
        validator: validateTenant,
        trigger: 'blur'
      }],
      username: [{
        required: true,
        trigger: "blur",
        message: "请输入账号"
      }],
      password: [{
        required: true,
        trigger: "blur",
        message: "请输入密码"
      }]
    };
    // 在需要跳转的地方执行
    const handleRedirect = () => {
      // router.push('/resetpassword')
      // 或者带查询参数
      router.push({
        path: '/resetpassword',
        query: {
          type: ruleForm.type
        }
      });
    };
    onMounted(() => {
      // 获取系统配置
      getSystemInfo().then(res => {
        logo.value = res.data.logo;
        title.value = res.data.title;
        enableVerify.value = res.data["enabled_verify"];
      }).catch(e => {
        showMessageError("获取系统配置失败：" + e.message);
      });
      getLicenseInfo().then(res => {
        licenseConfig.value = res.data;
      }).catch(e => {
        showMessageError("获取 License 配置：" + e.message);
      });

      // checkSession()
      //   .then(() => {
      //     if (isMobile()) {
      //       router.push("/mobile");
      //     } else {
      //       router.push("/ai/chat");
      //     }
      //   })
      //   .catch(() => {});

      // const returnURL = `${location.protocol}//${location.host}/login/callback?action=login`;
      // httpGet("/user/clogin?return_url=" + returnURL)
      //   .then((res) => {
      //     wechatLoginURL.value = res.data.url;
      //   })
      //   .catch((e) => {
      //     console.error(e);
      //   });
    });
    const handleKeyup = e => {
      if (e.key === "Enter") {
        login();
      }
    };

    // 获取租户 ID
    const loadTenantId = async () => {
      if (ruleForm.type === 'enterprise') {
        const res = await LoginApi.getTenantIdByCode(ruleForm.tenantCode);
        if (!res) {
          showMessageInfo("租户编码不存在！");
          return false;
        }
        authUtil.setTenantId(res);
      } else {
        authUtil.setTenantId(1);
      }
      return true;
    };
    const login = async function () {
      await ruleFormRef.value.validate(async valid => {
        if (valid) {
          if (enableVerify.value) {
            captchaRef.value.loadCaptcha();
          } else {
            await doLogin({});
          }
        }
      });
    };
    const store = useSharedStore();
    const doLogin = async verifyData => {
      if (!(await loadTenantId())) {
        return;
      }
      httpPost("/system/auth/mobile-login", {
        mobile: ruleForm.username,
        password: ruleForm.password,
        key: verifyData.key,
        dots: verifyData.dots,
        x: verifyData.x
      }).then(res => {
        // setUserToken(res.data.token);
        authUtil.setToken(res);
        // store.setIsLogin(true);
        // checkSession()
        // .then(() => {
        //   if (isMobile()) {
        //     router.push("/mobile");
        //   } else {
        if (ruleForm.type === 'enterprise') {
          // router.push("/aip/org-app-center");
          // 通过路由参数告诉首页需要重定向
          router.push({
            path: "/",
            query: {
              redirect: "/aip/org-app-center"
            }
          });
        } else {
          router.push("/");
        }
        //   }
        // })
        // .catch(() => {});
        // if (isMobile()) {
        //   router.push("/mobile");
        // } else {
        //   router.push("/ai/chat");
        // }
      }).catch(e => {
        showMessageError("登录失败，" + e.message);
      });
    };
    return (_ctx, _cache) => {
      const _component_footer_bar = _resolveComponent("footer-bar");
      const _component_el_input = _resolveComponent("el-input");
      const _component_el_form_item = _resolveComponent("el-form-item");
      const _component_el_tab_pane = _resolveComponent("el-tab-pane");
      const _component_el_tabs = _resolveComponent("el-tabs");
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_form = _resolveComponent("el-form");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createVNode(_component_footer_bar)]), _createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createVNode(AccountTop, {
        userType: ruleForm.type
      }, {
        default: _withCtx(() => [wechatLoginURL.value !== '' ? (_openBlock(), _createElementBlock("div", _hoisted_5, [_createElementVNode("a", {
          href: wechatLoginURL.value,
          onClick: _cache[0] || (_cache[0] = $event => _unref(setRoute)(_unref(router).currentRoute.value.path))
        }, _cache[5] || (_cache[5] = [_createElementVNode("i", {
          class: "iconfont icon-wechat"
        }, null, -1), _createTextVNode("使用微信登录 ")]), 8, _hoisted_6)])) : _createCommentVNode("", true)]),
        _: 1
      }, 8, ["userType"]), _createElementVNode("div", _hoisted_7, [_createVNode(_component_el_form, {
        ref_key: "ruleFormRef",
        ref: ruleFormRef,
        model: ruleForm,
        rules: rules
      }, {
        default: _withCtx(() => [_createVNode(_component_el_tabs, {
          modelValue: ruleForm.type,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => ruleForm.type = $event),
          class: "demo-tabs"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_tab_pane, {
            label: "企业用户",
            name: "enterprise"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_form_item, {
              label: "租户编码",
              "label-position": "top",
              prop: "tenantCode"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_input, {
                modelValue: ruleForm.tenantCode,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => ruleForm.tenantCode = $event),
                placeholder: "请输入租户编码"
              }, null, 8, ["modelValue"])]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_el_tab_pane, {
            label: "个人用户",
            name: "personal"
          })]),
          _: 1
        }, 8, ["modelValue"]), _createVNode(_component_el_form_item, {
          label: "",
          prop: "username"
        }, {
          default: _withCtx(() => [_cache[6] || (_cache[6] = _createElementVNode("div", {
            class: "form-title"
          }, "账号", -1)), _createVNode(_component_el_input, {
            modelValue: ruleForm.username,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => ruleForm.username = $event),
            size: "large",
            placeholder: "请输入账号",
            onKeyup: handleKeyup
          }, null, 8, ["modelValue"])]),
          _: 1
        }), _createVNode(_component_el_form_item, {
          label: "",
          prop: "password"
        }, {
          default: _withCtx(() => [_createElementVNode("div", {
            class: "flex-between w100"
          }, [_cache[7] || (_cache[7] = _createElementVNode("div", {
            class: "form-title"
          }, "密码", -1)), _createElementVNode("div", {
            class: "form-forget text-color-primary",
            onClick: handleRedirect
          }, "忘记密码？")]), _createVNode(_component_el_input, {
            size: "large",
            modelValue: ruleForm.password,
            "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => ruleForm.password = $event),
            placeholder: "请输入密码",
            "show-password": "",
            autocomplete: "off",
            onKeyup: handleKeyup
          }, null, 8, ["modelValue"])]),
          _: 1
        }), _createVNode(_component_el_form_item, null, {
          default: _withCtx(() => [_createVNode(_component_el_button, {
            class: "login-btn",
            size: "large",
            type: "primary",
            onClick: login
          }, {
            default: _withCtx(() => _cache[8] || (_cache[8] = [_createTextVNode("登录")])),
            _: 1
          })]),
          _: 1
        })]),
        _: 1
      }, 8, ["model"])])])]), enableVerify.value ? (_openBlock(), _createBlock(Captcha, {
        key: 0,
        onSuccess: doLogin,
        ref_key: "captchaRef",
        ref: captchaRef
      }, null, 512)) : _createCommentVNode("", true)]);
    };
  }
};